import React from 'react';
import Swipeable from 'react-swipeable'

import Footer from './footer';

let classNames = require('classnames/bind');


class NavItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    renderTimer() {
        if (this.props.selected) {
            return (
                <div className="Nav-itemTimer" style={{width: this.props.progress + '%'}}></div>
            )
        }
    }

    render() {
        const navClasses = classNames("Nav-item", {"selected": this.props.selected});
        return (
            <button onClick={() => this.props.onClick(this.props.index)} className={navClasses}>
                {this.renderTimer()}
            </button>
        );
    };
}

class Slide extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    renderDescription() {
        if (this.props.index > 0) {
            return (
                <div className="Slide-side">
                    <div className="Slide-descriptionLabel">
                        Website
                    </div>
                    <div className="Slide-descriptionText">
                        <a href={`http://` + this.props.slide.url} target="_blank">
                            {this.props.slide.url}
                        </a>
                    </div>
                    <div className="Slide-descriptionLabel">
                        Founders
                    </div>
                    <div className="Slide-descriptionText">
                        {this.props.slide.founders}
                    </div>
                    <div className="Slide-descriptionLabel">
                        HQ
                    </div>
                    <div className="Slide-descriptionText">
                        {this.props.slide.hq}
                    </div>
                    <div className="Slide-descriptionLabel">
                        Vision
                    </div>
                    <div className="Slide-descriptionText">
                        {this.props.slide.vision}
                    </div>
                    <div className="Slide-descriptionLabel">
                        Milestone
                    </div>
                    <div className="Slide-descriptionText">
                        {this.props.slide.milestone}
                    </div>
                    <div className="Slide-descriptionLabel">
                        Invested
                    </div>
                    <div className="Slide-descriptionText">
                        {this.props.slide.invested}
                    </div>
                    <div className="Slide-descriptionLabel">
                        Investors
                    </div>
                    <div className="Slide-descriptionText">
                        {this.props.slide.investors}
                    </div>
                </div>
            )
        }
    }

    render() {
        const slideClasses = classNames("Slide", {"selected": this.props.selected});

        return (
            <div
                className={slideClasses}
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL + this.props.slide.image})`,
                    backgroundColor: this.props.slide.color
                }}
            >
                <div className="Slide-main">
                    <h1
                        className="Type-h1 Slide-title Type-reverse"
                        dangerouslySetInnerHTML={{__html: this.props.slide.name}}
                    >
                    </h1>
                    <h3 className="Type-h3 Type-reverse">
                        {this.props.slide.description}
                    </h3>
                </div>
                {this.renderDescription()}
            </div>
        );
    };
}

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            maxCount: 80,
            currentCount: 0,
            slide: 0,
            slides: [
                {
                    "color": "#073445",
                    "name": "Foolhardy, Crazy.<br/>Visionary, Champion.",
                    "description": "We help the misunderstood turn renegade thoughts into revolutionary companies.",
                    "image": "/img/home.jpg"
                },
                {
                    "color": "#54AA4A",
                    "name": "Instacart",
                    "description": "Delivering the future of food.",
                    "url": "www.instacart.com",
                    "founders": "Apoorva Mehta, Max Mullen, Brandon Leonardo",
                    "hq": "San Francisco, CA",
                    "vision": "On-demand grocery delivery",
                    "milestone": "Partnered w/the 8 largest grocers in North America across 220 markets",
                    "invested": "Seed, Series D",
                    "investors": "Sequoia Capital, Andreessen, Kleiner Perkins",
                    "image": "/img/instacart.jpg"
                },
                {
                    "color": "#1D6DCA",
                    "name": "Coinbase",
                    "description": "Building an open financial system on the blockchain.",
                    "url": "www.coinbase.com",
                    "founders": "Brian Armstrong, Fred Ehrsam",
                    "hq": "San Francisco, CA",
                    "vision": "Bitcoin, digital currency, and decentralized apps for everyone",
                    "milestone": ">$150B traded, >20M users, available in >30 countries",
                    "invested": "Seed, Series A, Series D, Series E",
                    "investors": "Tiger Global, USV, Andreessen, DFJ, IVP",
                    "image": "/img/coinbase.jpg"
                },
                {
                    "color": "#feb71b",
                    "name": "Rippling",
                    "description": "The OS for work",
                    "url": "www.rippling.com",
                    "founders": "Parker Conrad, Prasanna Sankar",
                    "hq": "San Francisco, CA",
                    "vision": "The OS for work",
                    "milestone": "$35B payroll processed, 30k devices managed",
                    "invested": "Seed, Series A",
                    "investors": "Sequoia Capital, Founders Fund",
                    "image": "/img/rippling.jpg"
                },
                {
                    "color": "#554884",
                    "name": "GitLab",
                    "description": "Code collaboration.",
                    "url": "www.gitlab.com",
                    "founders": "Sid Sijbrandij, Dmitriy 'DZ' Zaporozhets",
                    "hq": "San Francisco, CA",
                    "vision": "Leader in open source git",
                    "milestone": "Used by >100,000 organizations like Bayer, NASA, Sony, and NASDAQ",
                    "invested": "Seed, Series B",
                    "investors": "Khosla Ventures, August Capital",
                    "image": "/img/gitlab.jpg"
                },
                {
                    "color": "#146ef6",
                    "name": "Webflow",
                    "description": "Visual development platform to democratize software creation",
                    "url": "www.webflow.com",
                    "founders": "Vlad Magdalin, Sergie Magdalin, Bryant Chou",
                    "hq": "San Francisco, CA",
                    "vision": "Visual development platform to democratize software creation",
                    "milestone": "3.5M+ users",
                    "invested": "Seed, Series A, Series B, Series C",
                    "investors": "Accel",
                    "image": "/img/webflow.jpg"
                },
                {
                    "color": "#222",
                    "name": "Gecko Robotics",
                    "description": "Monitoring critical infrastructure globally",
                    "url": "www.geckorobotics.com",
                    "founders": "Jake Loosararian and Troy Demmer",
                    "hq": "Pittsburgh, PA",
                    "vision": "Keeping the world running",
                    "milestone": "Monitoring critical infrastructure globally",
                    "invested": "Seed, Series B, Series C",
                    "investors": "Founders Fund, USIT",
                    "image": "/img/geckorobotics.jpg"
                },
                {
                    "color": "#3067E9",
                    "name": "Flexport",
                    "description": "Connecting global trade.",
                    "url": "www.flexport.com",
                    "founders": "Ryan Petersen",
                    "hq": "San Francisco, CA",
                    "vision": "Tech-enabled air & ocean freight forwarding",
                    "milestone": "Working with >15,000 companies across >50 countries",
                    "invested": "Seed, pre-Series A, Series B",
                    "investors": "Founders Fund, First Round Capital, DST",
                    "image": "/img/flexport.jpg"
                },
                {
                    "color": "#efbf8f",
                    "name": "Eight Sleep",
                    "description": "Fuel human potential through sleep fitness",
                    "url": "www.eightsleep.com",
                    "founders": "Matteo Franceschetti, Massimo Andreasi Bassi, Alexandra Zatarain",
                    "hq": "New York, NY",
                    "vision": "Fuel human potential through sleep fitness",
                    "milestone": "Used by Elon Musk, Mark Zuckerberg, Tim Ferriss",
                    "invested": "Seed, Series B",
                    "investors": "Khosla Ventures, Founders Fund",
                    "image": "/img/eightsleep.jpg"
                },
                {
                    "color": "#2A3559",
                    "name": "Wonderschool",
                    "description": "Building homes away from homes for kids.",
                    "url": "www.wonderschool.com",
                    "founders": "Chris Bennett, Arrel Gray",
                    "hq": "San Francisco, CA",
                    "vision": "Boutique in-home childhood programs network",
                    "milestone": "",
                    "invested": "Seed, Series A",
                    "investors": "First Round Capital, Andreessen",
                    "image": "/img/wonderschool.jpg"
                },
                {
                    "color": "#ED8A33",
                    "name": "EquipmentShare",
                    "description": "Equipment rental for construction contractors.",
                    "url": "www.equipmentshare.com",
                    "founders": "William Schlacks, Jabbok Schlacks",
                    "hq": "Columbia, Missouri",
                    "vision": "Airbnb for construction equipment",
                    "milestone": ">2,500 customers, >20,000 rentals",
                    "invested": "Seed",
                    "investors": "Insight Venture Partners",
                    "image": "/img/equipmentshare.jpg"
                },
                {
                    "color": "#9AC552",
                    "name": "Zūm",
                    "description": "Safe and reliable kids’ rides and care.",
                    "url": "www.ridezum.com",
                    "founders": "Ritu Narayan, Vivek Garg",
                    "hq": "Redwood City, CA",
                    "vision": "Largest & most-trusted kids’ transport & care platform",
                    "milestone": "2M safe miles driven, 400,000 children safely transported",
                    "invested": "Seed, Series B",
                    "investors": "Sequoia Capital, Spark Capital",
                    "image": "/img/zum.jpg"
                },
                {
                    "color": "#F84C53",
                    "name": "Rappi",
                    "description": "Modernizing retail in Latin America.",
                    "url": "www.rappi.com",
                    "founders": "Simón Borrero, Felipe Villamarin, Sebastian Mejia",
                    "hq": "Bogotá, Columbia",
                    "vision": "On-demand retail across LatAm",
                    "milestone": "Operating in Columbia, Mexico, Brazil, Argentina, Chile",
                    "invested": "Seed",
                    "investors": "Andreessen, Sequoia Capital, Delivery Hero",
                    "image": "/img/rappi.jpg"
                },
                {
                    "color": "#318AC5",
                    "name": "HomeLight",
                    "description": "Using data for a better home selling experience.",
                    "url": "www.homelight.com",
                    "founders": "Drew Uher",
                    "hq": "San Francisco, CA",
                    "vision": "Data-driven real estate agent selection",
                    "milestone": "30M transactions analyzed, selling 29 days faster, for 3.5% more",
                    "invested": "Seed",
                    "investors": "Menlo Ventures, Crosslink Capital, Bullpen Capital",
                    "image": "/img/homelight.jpg"
                },
                {
                    "color": "#3FB0AD",
                    "name": "Shippo",
                    "description": "Multi-carrier logistics software.",
                    "url": "www.goshippo.com ",
                    "founders": "Laura Behrens Wu, Simon Kreuz",
                    "hq": "San Francisco, CA",
                    "vision": "Logistics API and cloud-based platform",
                    "milestone": ">35,000 customers, processed >50 million packages in one year",
                    "invested": "Seed, Series A, Series B",
                    "investors": "Softtech, USV, Bessemer",
                    "image": "/img/shippo.jpg"
                },
                {
                    "color": "#54C03B",
                    "name": "Aircall",
                    "description": "Cloud based call center software.",
                    "url": "www.aircall.io ",
                    "founders": "Olivier Pailhès, Jonathan Anguelov, Xavier Durand, Pierre Baptiste Béchu",
                    "hq": "Paris, France",
                    "vision": "The future of voice.",
                    "milestone": "Used by >3,000 companies including Uber",
                    "invested": "Seed, Series A, Series B",
                    "investors": "Balderton Capital, Draper Esprit",
                    "image": "/img/aircall.jpg"
                },
                {
                    "color": "#4183BB",
                    "name": "AppZen",
                    "description": "Expense report auditing.",
                    "url": "www.appzen.com ",
                    "founders": "Anant Kale, Kunal Verma",
                    "hq": "Santa Clara, CA",
                    "vision": "AI for back office automation",
                    "milestone": "Used by Amazon, Citi, Comcast, Salesforce, Airbus, and others",
                    "invested": "Seed, pre-Series A",
                    "investors": "Redpoint Ventures, Resolute Ventures",
                    "image": "/img/appzen.jpg"
                },
                {
                    "color": "#3379C7",
                    "name": "ShipBob",
                    "description": "Small business fulfillment and logistics.",
                    "url": "www.shipbob.com",
                    "founders": "Dhruv Saxena, Divey Gulati ",
                    "hq": "Chicago, IL",
                    "vision": "Level the playing field for all e-commerce businesses",
                    "milestone": "Nationwide Amazon-level logistics for SMBs",
                    "invested": "Seed, Series A, Series B",
                    "investors": "Bain Capital Ventures, Hyde Park",
                    "image": "/img/shipbob.jpg"
                },
                {
                    "color": "#F94D90",
                    "name": "Scentbird",
                    "description": "Fragrance subscription service.",
                    "url": "www.scentbird.com ",
                    "founders": "Mariya Nurislamova, Sergei Gusev, Andrei Rebrov",
                    "hq": "New York, NY",
                    "vision": "Bringing personalization and fun to fragrance.  ",
                    "milestone": "Used by >250,000 subscribers ",
                    "invested": "Seed, Series A",
                    "investors": "Goodwater Capital",
                    "image": "/img/scentbird.jpg"
                },
                {
                    "color": "#E88F41",
                    "name": "Chainalysis",
                    "description": "Preventing & detecting cryptocurrency fraud.",
                    "url": "www.chainalysis.com",
                    "founders": "Michael Gronager, Jan Moller, Jonathan Levin",
                    "hq": "New York, NY",
                    "vision": "Building trust in blockchains.",
                    "milestone": "Used by companies, governments, and agencies",
                    "invested": "Seed, Series A",
                    "investors": "Benchmark, Point Nine",
                    "image": "/img/chainalysis.jpg"
                },
                {
                    "color": "#F93F40",
                    "name": "UpKeep",
                    "description": "Mobile-first maintenance management software.",
                    "url": "www.onupkeep.com ",
                    "founders": "Ryan Chan",
                    "hq": "Los Angeles, CA",
                    "vision": "Empowering maintenance teams",
                    "milestone": ">40,000 users",
                    "invested": "Seed",
                    "investors": "Emergence Capital Partners, Bain Capital, Mucker Capital ",
                    "image": "/img/upkeep.jpg"
                },
                {
                    "color": "#3F6FA5",
                    "name": "Human Interest",
                    "description": "401(k) as a service.",
                    "url": "www.humaninterest.com ",
                    "founders": "Roger Lee, Paul Sawaya",
                    "hq": "San Francisco, CA",
                    "vision": "A secure financial future for everyone",
                    "milestone": ">10,000 employees saving, >98% customer satisfaction",
                    "invested": "Seed, Series A ",
                    "investors": "Wing Venture Capital, Softtech",
                    "image": "/img/humaninterest.jpg"
                },
                {
                    "color": "#AC2E34",
                    "name": "Octane Lending",
                    "description": "Fast, easy powersports lending for dealers.",
                    "url": "www.octanelending.com ",
                    "founders": "Jason Guss, Mark Garro, Andre Gregori, Mark Davidson",
                    "hq": "New York, NY",
                    "vision": "Enabling everyone to purchase the powersports unit of their dreams.",
                    "milestone": ">2,500 dealers, >$1B loans requested",
                    "invested": "Seed, Series A, Series B",
                    "investors": "IA Ventures, Valar Ventures, Third Prime Capital",
                    "image": "/img/octanelending.jpg"
                },
                {
                    "color": "#3898E6",
                    "name": "Lob",
                    "description": "API for printing and mailing.",
                    "url": "www.lob.com ",
                    "founders": "Harry Zhang, Leore Avidar",
                    "hq": "San Francisco, CA",
                    "vision": "Making the offline world programmable",
                    "milestone": "Used by >5,000 customers",
                    "invested": "Seed, Series B",
                    "investors": "First Round Capital, Polaris Partners",
                    "image": "/img/lob.jpg"
                },
                {
                    "color": "#775FD3",
                    "name": "SendBird",
                    "description": "API and SDK for in-app messaging.",
                    "url": "www.sendbird.com ",
                    "founders": "John Kim, Harry Kim, Brandon Jeon, Forest Lee",
                    "hq": "San Mateo, CA",
                    "vision": "Digitizing human interactions for businesses",
                    "milestone": "Used by >7,000 apps ",
                    "invested": "Seed, Series A",
                    "investors": "Shasta Ventures, August Capital",
                    "image": "/img/sendbird.jpg"
                }
            ]
        };
        this.goToSlide = this.goToSlide.bind(this);
    }

    componentDidMount() {
        this.intervalId = setInterval(this.timer.bind(this), 100);
        this.goToSlide(0);
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    getPreviousSlide() {
        let currentSlide = this.state.slide
        let totalSlides = this.state.slides.length
        if (currentSlide === 0) {
            return totalSlides - 1;
        } else {
            return currentSlide - 1;
        }
    }

    getNextSlide() {
        let currentSlide = this.state.slide
        let totalSlides = this.state.slides.length
        if (currentSlide === totalSlides - 1) {
            return 0;
        } else {
            return currentSlide + 1;
        }
    }

    goToSlide(slide) {
        this.setState({
            currentCount: this.state.maxCount,
            slide: slide
        }, () => {
            console.log('slide: ' + this.state.slide);
        })
    }

    handleTap(event) {
        // Prevents React from resetting its properties: https://reactjs.org/docs/legacy-event-pooling.html
        event.persist();
        let tap_x = event.changedTouches[0].clientX;

        if (tap_x < window.innerWidth / 3) {
            this.goToSlide(this.getPreviousSlide());
        } else if (tap_x > window.innerWidth - (window.innerWidth / 3)) {
            this.goToSlide(this.getNextSlide());
        }
    }

    timer() {
        this.setState({
            currentCount: this.state.currentCount - 1
        })
        if (this.state.currentCount < 1) {
            this.goToSlide(this.getNextSlide());
        }
    }

    render() {
        let slides = this.state.slides;
        return (
            <div>
                <div className="HomeContainer">
                    <div className="Slides">
                        {slides.map((slide, index) => {
                            const selected = this.state.slide === index;
                            return (
                                <Swipeable
                                    key={index}
                                    preventDefaultTouchmoveEvent // prevent default IOS navigation
                                    onSwipedLeft={() => this.goToSlide(this.getNextSlide())}
                                    onSwipedRight={() => this.goToSlide(this.getPreviousSlide())}
                                    onTap={(e) => this.handleTap(e)}
                                >
                                    <Slide
                                        slide={slide}
                                        selected={selected}
                                        index={index}
                                        key={index}
                                    />
                                </Swipeable>
                            )
                        })}
                    </div>
                    <div className="Nav">
                        {slides.map((slide, index) => {
                            const selected = this.state.slide === index;
                            const progress = this.state.currentCount / this.state.maxCount * 100;
                            return (
                                <NavItem
                                    progress={progress}
                                    index={index}
                                    selected={selected}
                                    onClick={(index) => this.goToSlide(index)}
                                    key={index}
                                />
                            );
                        })}
                    </div>
                </div>
                <div className="HomeFooter">
                    <Footer/>
                </div>
            </div>
        );
    };
}
export default Home;



// WEBPACK FOOTER //
// ./src/components/home.js